import axios from 'axios';

const API = process.env.REACT_APP_BACKEND_URL + '/api';

/**
 * Beobachtet eine Rechnung nach dem Start einer Online-Zahlung (Payrexx öffnet
 * einen neuen Tab). Sobald der Nutzer zur App zurückkehrt (visibility/focus),
 * wird `/portal/invoices` gepollt; wird die Rechnung als "paid" erkannt, feuert
 * `onPaid(invoice)` genau einmal und die Listener werden entfernt.
 *
 * Gibt eine cleanup()-Funktion zurück (beim Unmount aufrufen).
 */
export function watchInvoicePayment({ token, invoiceId, onPaid, maxMs = 15 * 60 * 1000 }) {
  let done = false;
  const headers = { Authorization: `Bearer ${token}` };

  const check = async () => {
    if (done) return;
    try {
      const res = await axios.get(`${API}/portal/invoices`, { headers });
      const inv = (res.data?.invoices || []).find((i) => i.id === invoiceId);
      if (inv && inv.status === 'paid') {
        done = true;
        cleanup();
        onPaid(inv);
      }
    } catch (e) {
      /* still/leise – transient */
    }
  };

  const onVisible = () => {
    if (done) return;
    if (document.visibilityState === 'visible' || document.hasFocus()) {
      // Webhook kann ein paar Sekunden brauchen → mehrfach prüfen
      check();
      setTimeout(check, 2500);
      setTimeout(check, 6000);
    }
  };

  document.addEventListener('visibilitychange', onVisible);
  window.addEventListener('focus', onVisible);
  const timer = setTimeout(cleanup, maxMs);

  function cleanup() {
    done = true;
    document.removeEventListener('visibilitychange', onVisible);
    window.removeEventListener('focus', onVisible);
    clearTimeout(timer);
  }

  return cleanup;
}
